/* istanbul ignore file: Directive */
'use strict';

customerZone.directive('notApplicablePage', function(){
    return {
        template: '<div class="not-applicable-page"><p translate>' +
            'at_this_moment_this_page_is_not_applicable_to_you</p></div>'
    };
});
